import { appIntl } from '@components/locale/IntlGlobalProvider';

import { MapIdEnum, OperationalMapId } from '@/types/map.types';
import { MenuItemOption } from '@/types/menu.types';

import { FeatureTypeToContextComponentEnum, MenuBuilder, MenuKey } from '../type';
import { buildCreateEventOption, buildMeasureOption, buildQrCodeOption, CommonContextMenuContext } from './common';
import { createContextMenuDynamicOptions } from './utils';

export type PoiContextCore = {
  isPoiActive: boolean;
  handleActivatePoi: () => void;
};

export type PoiContextMenuContext = CommonContextMenuContext & PoiContextCore;

export type PoiContextMenuDynamicOptions = {
  activatePoi: boolean;
};

export type PoiContextMenuOptions = PoiContextMenuDynamicOptions;

export const POI_REPLAY_EVENT_DEFAULT_CONTEXT_MENU_DYNAMIC_OPTIONS: PoiContextMenuDynamicOptions = {
  activatePoi: true,
};

const allTrue = createContextMenuDynamicOptions(POI_REPLAY_EVENT_DEFAULT_CONTEXT_MENU_DYNAMIC_OPTIONS, true);
const allFalse = createContextMenuDynamicOptions(POI_REPLAY_EVENT_DEFAULT_CONTEXT_MENU_DYNAMIC_OPTIONS, false);

export const poiContextMenuConfig: Record<OperationalMapId, PoiContextMenuDynamicOptions> = {
  [MapIdEnum.LIVE]: allTrue,
  [MapIdEnum.LAD]: allTrue,
  [MapIdEnum.REPLAY]: allFalse,
  [MapIdEnum.STATISTICS]: allFalse,
};

const buildActivatePoiOption: MenuBuilder<FeatureTypeToContextComponentEnum.POI>['build'] = (
  ctx,
): [MenuKey, MenuItemOption] => {
  const formatMessage = appIntl().formatMessage;
  return [
    'activatePoi',
    {
      label: formatMessage({ id: 'contextmenu.actions.activateDeactivate' }, { active: !ctx.isPoiActive }),
      shouldNotTranslate: true,
      onAction: ctx.handleActivatePoi,
    },
  ];
};

export const poiBuilders: MenuBuilder<FeatureTypeToContextComponentEnum.POI>[] = [
  {
    order: 1,
    build: buildQrCodeOption,
  },
  {
    order: 2,
    build: buildMeasureOption,
  },
  {
    order: 3,
    build: buildCreateEventOption,
  },
  {
    order: 4,
    separator: true,
  },
  {
    order: 5,
    build: buildActivatePoiOption,
  },
];
